import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ChatWindow from '@/pages/live-chat/components/ChatWindow';

export default function LiveChat() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar />

      <main className="pt-16 flex-1 flex flex-col">
        <div className="mx-auto w-full max-w-3xl px-4 md:px-6 py-4 flex-1 flex flex-col">
          {/* Breadcrumb */}
          <div className="flex items-center gap-2 text-sm text-foreground-600 mb-4">
            <Link to="/" className="hover:text-primary-300 cursor-pointer">Trang chủ</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-900">Chat hỗ trợ</span>
          </div>

          <h1 className="text-xl md:text-2xl font-bold text-foreground-950 mb-4">Chat với hỗ trợ viên</h1>

          <div className="flex-1 flex flex-col min-h-[520px]">
            <ChatWindow />
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}